import React, { Component } from 'react';
import { ProgressbarCommand } from './datamanager/commands/ProgressbarCommand';
import { ProgressBar } from 'react-bootstrap';

export class Progressbar extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {
                id: undefined === this.props.data ? undefined : this.props.data.id,
                progress: 0,
                log: "",
                timestamp: 0,
                status: 0
            },
            commands: {
                progressbarCommand: new ProgressbarCommand(),
            },
            isCompleted: false,
            previousInputValue: undefined,
        }
    }

    componentDidMount() {
        const statusMessage = this.props.statusMessage;

        this.getProgressbar(this.props.data);

        this.setState({
            previousInputValue: statusMessage
        });
    }

    getProgressbar() {
        const { data } = this.state;

        if (undefined === data.id) {
            return;
        }

        const { commands } = this.state;

        commands.progressbarCommand.get(
            data,
            (a) => this.progressbarSuccessCallback(a),
            (a) => this.progressbarErrorCallback(a)
        );
    }

    progressbarSuccessCallback(result) {
        if (100 > result.progress) {
            this.setState({
                data: result
            }, () => this.getProgressbar());

            return;
        }

        if ("function" === typeof this.props.success) {
            this.props.success(this.props.data);
        }

        this.setState({
            data: result
        });
    }

    progressbarErrorCallback(error) {
        if ("function" === typeof this.props.error) {
            this.props.error(error);
        }
    }

    renderPbar() {
        const { message, statusMessage } = this.props;
        const { data } = this.state;

        switch (statusMessage) {
            case 'isRunning':
                return (
                    <div>
                        <ProgressBar active bsStyle="info" now={(data !== undefined) ? data.progress : 0} />
                        <div>{(undefined !== data && undefined !== data.log && "" !== data.log) ? data.log : "A iniciar..."}</div>
                    </div>
                );

            case 'Error':
                return (
                    <div>
                        <ProgressBar active bsStyle="danger" now={100} />
                        <div>{(message !== undefined) ? message : "Ocorreu um erro!"}</div>
                    </div>
                );

            case 'Success':
                return (
                    <div>
                        <ProgressBar active bsStyle="success" now={100} />
                        <div>{"Sucesso!"}</div>
                    </div>
                );
            case 'Pending':
                return (
                    <div>
                        <ProgressBar striped bsStyle="warning" now={100} />
                        <div>{(message !== undefined) ? message : "A preparar..."}</div>
                    </div>
                );

            default:
                return null;
        }
    }

    render() {
        return (
            this.renderPbar()
        );
    }
}
